import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const logoUrl = "https://media.wasacon.de/valerirudtmedia/_assets/media/f7ab0f15bdace7517b11de1159f9cce9.jpg";

  return (
    <footer className="bg-zinc-950 border-t border-zinc-900 pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand & Logo */}
          <div>
            <Link to="/" className="inline-block mb-6 group">
              <div className="relative">
                <img 
                  src={logoUrl} 
                  alt="Valeri Rudt Media Logo" 
                  className="h-20 w-auto rounded-sm border border-zinc-800 grayscale group-hover:grayscale-0 transition-all duration-500 object-cover shadow-2xl shadow-orange-500/10"
                />
                <div className="absolute -bottom-2 -right-2 bg-orange-500 text-zinc-950 text-[10px] font-black px-2 py-0.5 uppercase tracking-tighter">
                  Media
                </div>
              </div>
            </Link>
            <div className="mb-4">
              <Link to="/" className="text-xl font-black tracking-tighter uppercase text-white flex items-center gap-1">
                VALERI RUDT <span className="text-orange-500">.</span>
              </Link>
            </div>
            <p className="text-zinc-400 text-sm max-w-xs leading-relaxed">
              Echter Baustellen-Alltag &ndash;&gt; ungefiltert, direkt und auf den Punkt. 
              Content & GEO-KI für Marken, die sichtbar werden wollen.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 text-sm border-l-2 border-orange-500 pl-3">
              Navigation
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm font-medium">
              <li><Link to="/" className="hover:text-orange-500 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-zinc-800 rounded-full"></span> Startseite</Link></li>
              <li><a href="/#services" className="hover:text-orange-500 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-zinc-800 rounded-full"></span> Leistungen</a></li>
              <li><a href="/#cooperation" className="hover:text-orange-500 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-zinc-800 rounded-full"></span> Zusammenarbeit</a></li>
              <li><a href="/#contact" className="hover:text-orange-500 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-zinc-800 rounded-full"></span> Kontakt</a></li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 text-sm border-l-2 border-orange-500 pl-3">
              Connect
            </h4>
            <a href="mailto:info@valerirudtmedia.de" className="group text-zinc-400 text-sm hover:text-orange-500 transition-colors flex items-center gap-3 mb-6 bg-zinc-900/50 p-3 border border-zinc-800 rounded-sm">
              <div className="w-8 h-8 bg-zinc-950 flex items-center justify-center rounded-sm text-orange-500 group-hover:bg-orange-500 group-hover:text-zinc-950 transition-all">
                <SafeIcon icon={FiIcons.FiMail} />
              </div>
              <span className="font-semibold">info@valerirudtmedia.de</span>
            </a>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/v.rudt/" 
                target="_blank" 
                rel="noreferrer" 
                className="w-12 h-12 bg-zinc-900 border border-zinc-800 rounded-sm flex items-center justify-center text-zinc-400 hover:bg-orange-500 hover:text-zinc-950 hover:border-orange-500 transition-all group"
                title="Instagram"
              >
                <SafeIcon icon={FiIcons.FiInstagram} className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
              <a 
                href="https://www.youtube.com/@ValeriRudt-n2l/shorts" 
                target="_blank" 
                rel="noreferrer" 
                className="w-12 h-12 bg-zinc-900 border border-zinc-800 rounded-sm flex items-center justify-center text-zinc-400 hover:bg-orange-500 hover:text-zinc-950 hover:border-orange-500 transition-all group"
                title="YouTube"
              >
                <SafeIcon icon={FiIcons.FiYoutube} className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-600 text-[10px] uppercase font-bold tracking-widest">
            &copy; {currentYear} Valeri Rudt Media. Power of Real Content.
          </p>
          <div className="flex gap-8 text-[11px] font-bold uppercase tracking-widest text-zinc-600">
            <Link to="/impressum" className="hover:text-orange-500 transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-orange-500 transition-colors">Datenschutz</Link>
            <Link to="/social-impressum" className="hover:text-orange-500 transition-colors">Social Impressum</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;